import React from "react"
import style from "../components/landingMobile.module.scss"

export default function LandingMobile() {
  return (
    <div className={style.wrapper} id="landing">
      <h1>
        Zeven
        <br />
        kunstenaars
        <br />
        <span className={style.glue}>onderzoeken en</span>
        <br />
        <span className={style.glue}>verbeelden de</span>
        <br />
        textielverhalen
        <br />
        <span className={style.glue}>van Amersfoort</span>
      </h1>
    </div>
  )
}
